import React, { useEffect } from 'react';

import { Helmet } from 'react-helmet-async';
import { setSubpage } from '../../../routes/routerSlice';
import { ProjectAdministrationSubpage } from '../projectAdministrationLib';
import { MainContentWrapper } from '@ydistri/ds';
import { useAppDispatch } from '../../../store';
import { YPICK_LABEL } from '../../../components/global/_constants';
import StoreDepartmentCredentialsSection from './StoreDepartmentCredentialsSection';

const YPickCredentialsAdministration: React.FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setSubpage(ProjectAdministrationSubpage.YPICK_CREDENTIALS));
  }, [dispatch]);

  return (
    <>
      <Helmet title={`${YPICK_LABEL} Credentials Administration`} />
      <MainContentWrapper>
        <StoreDepartmentCredentialsSection />
      </MainContentWrapper>
    </>
  );
};

export default YPickCredentialsAdministration;
